<template>
  <div>
    <p>
      From: {{bindSalePerson()}} <br />
      <strong>{{hotel.name}}</strong> <br />
      <span v-html="bindHotelInfo"></span>
    </p>
  </div>
</template>
<script>
import { get } from 'lodash'
import HotelApi from '@/api/hotel-api'
export default {
  name: 'SalePerson',
  props: {
    salePerson: {
      type: Object,
      default: () => {
        return {}
      }
    },
    hotel: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      displayHotelInformation: {}
    }
  },
  created: async function () {
    await this.getHotelInfo(this.hotel)
  },
  methods: {
    getHotelInfo: async function (hotel) {
      const hotelInfo = await HotelApi.info(hotel.id)
      this.displayHotelInformation = hotelInfo
    },
    bindSalePerson: function () {
      const title = get(this.salePerson, 'title', '')
      const firstName = get(this.salePerson, 'firstName', '')
      const lastName = get(this.salePerson, 'lastName', '')
      const position = get(this.salePerson, 'position', '')
      const positionStr = (position === '') ? '' : `(${position})`

      return `${title} ${firstName} ${lastName} ${positionStr}`
    }

  },
  watch: {
    hotel (hotel) {
      this.getHotelInfo(hotel)
    }
  },
  computed: {
    bindHotelInfo () {
      const address = get(this.displayHotelInformation, 'address', '')
      const emailList = get(this.displayHotelInformation, 'information.emailList', [])
      const phoneList = get(this.displayHotelInformation, 'information.phoneList', [])
      const faxList = get(this.displayHotelInformation, 'information.faxList', [])
      const emailStr = (emailList.length > 0) ? `Email: ${emailList.join(', ')}` : ''
      const phoneStr = (phoneList.length > 0) ? `Tel: ${phoneList.join(', ')}` : ''
      const faxStr = (faxList.length > 0) ? `Fax: ${faxList.join(', ')}` : ''

      return `${address} <br>${phoneStr} <br>${emailStr} <br>${faxStr}`
    }
  }
}
</script>
